<template>
  <div :class="{ 'flex-nowrap flex items-center': hasIcon }">
    <div
      class="group z-auto flex items-center m-2 cursor-pointer"
      :class="{
        'md:ml-1 w-max': hasIcon,
        'lg:hidden': mobileOnly
      }"
    >
      <div
        v-if="hasIcon"
        class="hover-hover:group-hover:bg-brand z-10 p-2 -m-1 -mr-1 border rounded-full"
        :class="{
          'hover-hover:group-hover:bg-accent hover-hover:group-hover:text-brand bg-brand text-white': isBrand,
          'hover-hover:group-hover:bg-brand hover-hover:group-hover:text-accent bg-accent text-brand': isAccent
        }"
      >
        <component :is="iconComponent" class="w-6 h-6" />
      </div>
      <component
        :class="{
          'uppercase font-bold text-xl': cta,
          'rounded-2xl text-center text-lg py-2 ': !hasIcon,
          'text-sm border-l-0 rounded-full rounded-l-none pl-3 py-1': hasIcon,
          'cursor-pointer': !link,
          'w-full max-w-xs mx-auto my-2': fullWidth,
          'hover-hover:group-hover:bg-primary': isNormal,
          'bg-accent text-brand hover-hover:group-hover:bg-brand hover-hover:group-hover:text-accent':
            isAccent && !hasIcon,
          'bg-accent text-brand': isAccent && hasIcon,
          'bg-brand text-white hover-hover:group-hover:bg-accent hover-hover:group-hover:text-brand':
            isBrand && !hasIcon,
          'bg-brand text-white': isBrand && hasIcon
        }"
        :is="link || packageId ? (external ? 'a' : 'router-link') : 'div'"
        :target="{ _blank: external }"
        v-bind:[linkType]="navLink"
        v-bind="$attrs"
        class="p-4 border"
        ><slot />
        {{ text }}
      </component>
    </div>
    <img v-if="label" class="w-10 h-10 ml-2" :src="label" />
  </div>
</template>

<script>
import _ from "lodash";
import DownloadIcon from "@/components/icons/DownloadIcon";
import PlayIcon from "@/components/icons/PlayIcon";
import querystring from "querystring";
import { mapGetters } from "vuex";

export default {
  components: { DownloadIcon, PlayIcon },
  props: {
    cta: Boolean,
    fullWidth: Boolean,
    link: {
      type: String,
      default: null
    },
    text: { default: "Apri Conto" },
    icon: String,
    external: Boolean,
    label: String,
    mobileOnly: Boolean,
    packageId: String,
    buttonStyle: {
      type: String,
      default: "normal"
    }
  },
  computed: {
    ...mapGetters(["trackers"]),
    navLink() {
      let link = "";

      if (_.isEmpty(this.trackers.codice)) {
        link = this.packageId
          ? process.env.VUE_APP_PLUGIN_APRICONTO
          : this.link;
      } else {
        link =
          process.env.VUE_APP_PLUGIN_APRICONTO_CONVENZIONE +
          this.trackers.codice;
      }

      let linkUrl =
        this.link && this.external
          ? new URL(
              this.link == "{VUE_APP_APRICONTO}"
                ? process.env.VUE_APP_APRICONTO
                : this.link
            )
          : null;

      link = linkUrl ? linkUrl.origin + linkUrl.pathname : link;

      const prevQs = linkUrl && querystring.decode(linkUrl.search.slice(1));
      const qs = { ...this.trackers, ...prevQs };

      let params = this.packageId ? { ...qs, package: this.packageId } : qs;

      params = querystring.encode(_.pickBy(params, _.identity));

      // this method is a workaround to manage the external link when the tracker is present
      if (this.isValidUrl(link)) {
        if (
          new URL(link).pathname ===
            new URL(process.env.VUE_APP_APRICONTO).pathname &&
          this.trackers.codice
        ) {
          link =
            process.env.VUE_APP_PLUGIN_APRICONTO_CONVENZIONE +
            this.trackers.codice;
        }
      }

      const goto = this.external ? `${link}${params && "?"}${params}` : link;

      return goto;
    },
    linkType() {
      return this.external ? "href" : "to";
    },
    hasIcon() {
      return !_.isEmpty(this.icon);
    },
    iconComponent() {
      switch (this.icon) {
        case "video":
          return "PlayIcon";
        default:
          return "DownloadIcon";
      }
    },
    isNormal() {
      return this.buttonStyle == "normal";
    },
    isBrand() {
      return this.buttonStyle == "brand";
    },
    isAccent() {
      return this.buttonStyle == "accent";
    }
  },
  methods: {
    isValidUrl(string) {
      try {
        new URL(string);
      } catch (_) {
        return false;
      }

      return true;
    }
  }
};
</script>
